"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./loader.scss");

var _jsxRuntime = require("react/jsx-runtime");

var Loader = function Loader(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "".concat(!!className ? "".concat(className, " ") : '', "p-loader-wrapper"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "p-loader"
    })
  });
};

var _default = Loader;
exports["default"] = _default;